import React, { useEffect, useState } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import DataTable from "react-data-table-component";

//Redux
import { useDispatch, useSelector } from "react-redux";

//Components
import Layout from "../../../../Layout/Layout";
import CustomerConstants from "../../../../common/CustomerConstants";

import DeleteMaterial from "./DeleteMaterial";
import CatalogProductDetailModal from "../Common/CatalogModal/CatalogProductDetailModal";

import MaterialHBModal from "./MaterialHBModal";
import {
  addMaterial,
  getMaterialList,
} from "../../../../redux/feature/customer_app/customerV1Slice";
import { SearchField } from "../../../../Components/formElements/SearchField";
import FileViewerModal from "../../../../Components/FileViewer/FileViewerModal";
import ShowUploadImage from "./ShowUploadImage";
import MultiColumnFilter from "../../../../Components/Filter/MultiColumnFilter";
import TableActions from "../Common/TableActions/TableActions";
import DetailCell from "../Common/TableActions/DetailCell";
// import { formatDate } from "../../../../common/Validations";

const Material = () => {
  localStorage.setItem("menu", "Master");
  localStorage.setItem("submenu", "Material Master");

  const dispatch = useDispatch();

  let materialData = useSelector((state) => state?.customerV1?.material?.data); // User Details from Store
  let materialTable = useSelector(
    (state) => state?.customerV1?.material?.pagination,
  );

  const [getCommonSearchTxt, setCommonSearchTxt] = useState("");
  const [getNewPerPage, setNewPerPage] = useState(10);

  const [modalDeleteMaterial, setModalDeleteMaterial] = useState(false);
  const [modalShowAddProduct, setModalShowAddProduct] = useState(null);
  const [modalShowDetailProduct, setModalShowDetailProduct] = useState(false);

  const [isCardVisible2, setCardVisible2] = useState(true);

  const [getData, setData] = useState();
  const [getShowFileViewModal, setShowFileViewModal] = useState(false);
  // eslint-disable-next-line
  const [getFileViewData, setFileViewData] = useState(null);
  const columns = [
    {
      name: "Material",
      selector: (row) => row.productName || "--",
      cell: (row) => (
        <div
          className="flex justify-center items-center cursor-pointer"
          onClick={() => showAddProduct("DETAILS", row.documentNumber)}
        >
          <div className="w-75">
            <ShowUploadImage fileid={row?.materialImage} />
          </div>
        </div>
      ),
      sortable: true,
      width: "140px",
    },
    {
      name: "Code",
      id: "materialCode",
      // id1:"materialDescription",
      // dropDown: true,
      selector: (row) => row.productName || "--",
      cell: (row) => (
        // <div className="d-flex justify-content-center w-50 align-items-center cursor-pointer">

        <div className="flex justify-center items-center">
          <div className="ms-2">
            <p className="m-0 p-0 pt-1 fw-bold">{row?.materialCode} </p>

            <p className="m-0 p-0 pt-1 fw-bold text-success">
              {row.materialDescription}{" "}
            </p>
          </div>
        </div>
      ),
      sortable: true,
      width: "300px",
    },
    {
      name: "Unit",
      selector: (row) => row.unit || "--",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1">{row.unit} </p>
        </div>
      ),
      sortable: true,
      width: "80px",
    },
    {
      name: "Unit Weight",
      selector: (row) => row.unitWeight || "--",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold">{row.unitWeight} </p>
        </div>
      ),
      sortable: true,
      width: "130px",
    },
    {
      name: "Unit Price",
      selector: (row) => row.unitPrice || "--",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold">{row.unitPrice} </p>
        </div>
      ),
      sortable: true,
      width: "120px",
    },
    {
      name: "Material Grp ",
      id: "materialGroup",
      // dropDown:true,
      // dropDown: true,
      selector: (row) => row.materialGroup || "--",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1">{row.materialGroup} </p>
        </div>
      ),
      // sortable: true,
      width: "130px",
    },
    {
      name: "Attachments",
      selector: (row) => row.materialAttachments,
      cell: (row) => (
        <div
          style={{ width: "100%" }}
          className="d-flex justify-content-center cursor-pointer"
          // onClick={()=>showViewInvoice(row)}
          // onClick={() => handlePrintWithData(row)}
        >
          <img
            src="assets/img/newIcons/attached-file.png"
            alt="attachments"
            style={{ width: "25px" }}
            className="mt-1"
          />
        </div>
      ),
      sortable: true,
      width: "130px",
    },
    // {
    //   name: "Details",
    //   cell: (row) => (
    //     <div className="d-flex align-items-center gap-2">
    //       <OverlayTrigger
    //         placement="bottom"
    //         delay={{ show: 150, hide: 200 }}
    //         overlay={
    //           <Tooltip
    //             id={`tooltip-${row.documentNumber}`}
    //             className="custom-tooltip"
    //             target={target.current}
    //           >
    //             <div style={{ textAlign: "left" }}>
    //               <strong>Material GroupCode:</strong>{" "}
    //               {row?.materialGroupCode || "--"}
    //               <br />
    //               <strong>Material Category:</strong>{" "}
    //               {row?.materialCategory || "--"}
    //               <br />
    //               <strong>Suraface/Paint:</strong>{" "}
    //               {row?.unitSurfacePaint || "--"}
    //               <br />
    //               {/* ✅ Fix: buildingType is array of objects — render codes as string */}
    //               <strong>Building Type:</strong>{" "}
    //               {Array.isArray(row?.buildingType)
    //                 ? row.buildingType
    //                     .map((b) =>
    //                       typeof b === "object" ? b?.code || b?.name : b,
    //                     )
    //                     .join(", ") || "--"
    //                 : row?.buildingType || "--"}
    //               <br />
    //               <strong>Components:</strong> {row?.componentKey || "--"}
    //               <br />
    //               <strong>Remarks:</strong> {row?.remarks || "--"}
    //               <br />
    //               <strong>Created By:</strong> {row?.createdBy || "--"}
    //               <br />
    //               <strong>Created Date:</strong> {row?.createdDate || "--"}
    //               <br />
    //               <strong>Updated Date:</strong> {row?.updatedDate || "--"}
    //               <br />
    //             </div>
    //           </Tooltip>
    //         }
    //       >
    //         <button className="btn btn-light p-1 border-0" title="View Details">
    //           <i className="bi bi-eye fs-5 text-primary"></i>
    //         </button>
    //       </OverlayTrigger>
    //     </div>
    //   ),

    //   width: "100px",
    // },

    // {
    //   name: "Edit",
    //   selector: (row) => row.purchaseType || "--",
    //   cell: (row) => (
    //     <div>
    //       <button
    //         title="Edit"
    //         className="btn d-flex align-items-center w-100"
    //         // onClick={DeleteMaterial}
    //         onClick={() => showAddProduct("EDIT", row.documentNumber)}
    //       >
    //         <i class="bi bi-pencil-square pe-2"></i>{" "}
    //         {/* <sapn className="m-0 p-0 pt-1">Edit </sapn> */}
    //       </button>
    //     </div>
    //   ),
    //   sortable: true,
    //   width: "120px",
    // },
    // {
    //   name: "Delete",
    //   selector: (row) => row.purchaseType || "--",
    //   cell: (row) => (
    //     <div>
    //       <button onClick={() => deleteMaterial(row)}>
    //         {/* <i class="bi bi-trash3"></i> */}
    //         <i className="bi bi-trash text-danger fs-4" />
    //       </button>
    //     </div>
    //   ),
    //   sortable: true,
    //   width: "200px",
    // },
    {
      name: "Action",
      cell: (row) => (
        <TableActions
          actions={[
            {
              label: "Details",
              render: <DetailCell row={row} />, // ✅ only row, fields handled inside
            },
            {
              label: "Edit",
              icon: "bi bi-pencil-square",
              // bg: "#e6f7ee",
              onClick: () => showAddProduct("EDIT", row.documentNumber),
            },
            {
              label: "Delete",
              icon: "bi bi-trash",
              iconClass: "text-danger",
              // bg: "#fdeaea",
              onClick: () => deleteMaterial(row),
            },
            {
              label: "More",
              icon: "bi bi-three-dots",
              // bg: "#f1f3f5",
              onClick: () => console.log("More", row),
            },
          ]}
        />
      ),
      width: "180px",
    },
  ];

  const toggleCardVisibility2 = () => {
    setCardVisible2(!isCardVisible2);
  };

  // const handleViewFile = (fileAttachmentId) => {
  //   setFileViewData(fileAttachmentId);
  //   setShowFileViewModal(true);
  // };
  const handleViewFileHide = () => {
    setShowFileViewModal(false);
  };

  const deleteMaterial = (data) => {
    setModalDeleteMaterial(true);
    setData(data);
    dispatch(addMaterial(data.documentNumber));
  };
  const showAddProduct = (mode, materialnumber) => {
    setModalShowAddProduct(mode);

    if (mode === "EDIT") {
      dispatch(addMaterial(materialnumber));
    } else if (mode === "DETAILS") {
      dispatch(addMaterial(materialnumber));
    } else {
      dispatch(addMaterial(""));
    }
  };

  const hideModal = () => {
    setModalDeleteMaterial(false);
    setModalShowAddProduct(null);
    setModalShowDetailProduct(false);
  };

  useEffect(() => {
    let obj = {
      queryName: "Get_MATERIAL_LIST_CON",
      page: 1,
      per_page: 10,
    };
    dispatch(getMaterialList(obj));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handlePageChange = (page) => {
    let obj = {
      queryName: "Get_MATERIAL_LIST_CON",
      page: page,
      per_page: getNewPerPage,
    };
    dispatch(getMaterialList(obj));
  };
  const handlePerRowsChange = async (newPerPage, page) => {
    let obj = {
      queryName: "Get_MATERIAL_LIST_CON",
      page: page,
      per_page: newPerPage,
    };
    setNewPerPage(newPerPage);
    dispatch(getMaterialList(obj));
  };

  // Common Search Function on button
  const handleSearchFuncApi = async () => {
    let obj = {
      queryName: "Get_MATERIAL_LIST_CON",
      page: 1,
      per_page: 10,
      searchTerm: getCommonSearchTxt,
    };
    dispatch(getMaterialList(obj));
  };
  // const [data, setDataFilter] = useState();
  const [filterShow, setFilterShow] = useState(false);

  const handleFilterData = async (filters) => {
    const obj = {
      queryName: "Get_MATERIAL_LIST_CON",
      page: 1,
      per_page: 10,
      searchTerm: "",
      rowFilter: filters.length > 0 ? { $and: filters } : {},
    };

    // dispatch(getQtnJobList(obj));
    dispatch(getMaterialList(obj));

    // console.log(obj)
  };

  const columnsForFilter = columns
    .filter((col) => col.id || col.selectorKey)
    .map((col) => ({
      name: col.name,
      selectorKey: col.id || col.selectorKey,
      dropDown: col.dropDown || false,
      range: col.range || false,
      month: col.month || false,
    }));
  return (
    <main className="dashboard main" id="main">
      <Layout />
      <Row className="justify-center subContent">
        <Col xs={12} md={12} className="rightSide">
          <div className="rightSideInner PageCommonCSS">
            <Row>
              <Col xs={12} md={8} lg={8}>
                <h2 className="mainTitle"> Material Master</h2>
                <p className="subText">Material</p>
              </Col>
              <Col
                xs={12}
                md={3}
                lg={3}
                className="d-flex justify-content-end mt-3"
              >
                <SearchField
                  name="searchKey"
                  value={getCommonSearchTxt}
                  onChange={(event) => setCommonSearchTxt(event.target.value)}
                  onClick={() => handleSearchFuncApi()}
                />
              </Col>
              <Col xs={12} md={1} lg={1}>
                <span
                  className="filterIcon"
                  onClick={() => setFilterShow(!filterShow)}
                >
                  <i class="bi bi-filter"></i>
                </span>
              </Col>
            </Row>
            <hr />
            {filterShow && (
              <MultiColumnFilter
                columns={columnsForFilter}
                data={getData}
                onFilter={handleFilterData}
                onCancel={() => setFilterShow(false)}
              />
            )}
            {/* material */}
            <div className="accordion" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible2
                            ? "bi-chevron-down"
                            : "bi-chevron-right"
                        }`}
                        onClick={toggleCardVisibility2}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">MD</span>
                    </Col>
                    <Col xs={6} md={4} lg={4}>
                      <span className="headerTitle">Material Details</span>
                      <span className="subHeaderTitle">Material</span>
                    </Col>

                    <Col xs={12} md={8} lg={8} className="headerButtonAlign">
                      <Col xs={3} md={3} lg={3} className="">
                        <button className="btnTable d-flex justify-content-center">
                          <p className="m-0 me-2">
                            {" "}
                            <span className="mr-2">
                              <i class="bi bi-upload"></i>
                            </span>
                            Upload
                          </p>
                          {/* <i class="bi bi-plus-square"></i> */}
                        </button>
                      </Col>
                      <Col xs={3} md={3} lg={3} className="">
                        <button
                          className="btnTable d-flex justify-content-center"
                          onClick={() => showAddProduct("CREATE")}
                        >
                          <p className="m-0 me-2">Material Creation</p>
                          {/* <i class="bi bi-plus-square"></i> */}
                        </button>
                      </Col>
                    </Col>
                  </Row>
                </h2>
                <div
                  // id="acc"
                  className={`accordion-collapse collapse show ${
                    isCardVisible2 ? "visible" : ""
                  }`}
                  // aria-labelledby="headingOne"
                  // data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                    <Row>
                      <Col xs={12} md={12} lg={12}>
                        <DataTable
                          title=""
                          columns={columns}
                          data={materialData}
                          // progressPending={purchaseOrderData?.status}
                          paginationRowsPerPageOptions={
                            CustomerConstants.ROW_PER_PAGE
                          }
                          pagination
                          paginationServer
                          paginationTotalRows={materialTable.total}
                          onChangeRowsPerPage={handlePerRowsChange}
                          onChangePage={handlePageChange}
                          // onSelectedRowsChange={handleRowSelected}
                          selectableRows
                        />
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Col>
      </Row>
      <DeleteMaterial
        show={modalDeleteMaterial}
        onHide={() => hideModal()}
        data={getData}
        // dropdownData={getAccountGroup}
      />
      <MaterialHBModal
        show={modalShowAddProduct}
        onHide={() => hideModal()}
        // dropdownData={getAccountGroup}
      />
      <CatalogProductDetailModal
        show={modalShowDetailProduct}
        onHide={() => hideModal()}
      />
      <FileViewerModal
        show={getShowFileViewModal}
        onHide={handleViewFileHide}
        fileid={getFileViewData}
      />
    </main>
  );
};

export default Material;
